import { useEffect, useMemo, useState } from 'react';
import api from '../services/api';

/**
 * Load batched 30d / prior-30d metrics for visible store profile IDs.
 */
export default function useStorePerformanceSummaries(profileIds, { enabled = true } = {}) {
  const [summaries, setSummaries] = useState({});
  const [bounds, setBounds] = useState(null);
  const [loading, setLoading] = useState(false);

  const idsKey = useMemo(
    () => [...new Set((profileIds || []).map(String).filter(Boolean))].sort().join(','),
    [profileIds]
  );

  useEffect(() => {
    if (!enabled) return;
    const ids = idsKey ? idsKey.split(',') : [];
    if (!ids.length) {
      setSummaries({});
      setBounds(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    api
      .post('/stores/performance-summary', { profileIds: ids })
      .then((res) => {
        if (cancelled || !res.data?.success) return;
        setSummaries(res.data.summaries || {});
        setBounds(res.data.bounds || null);
      })
      .catch(() => {
        if (!cancelled) setSummaries({});
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [idsKey, enabled]);

  return { summaries, bounds, loading };
}
